/**
 * Service: rolesApi
 */
angular.module('acme.common.service.rolesApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('RolesApiService', [ '$http', 'QueryStringBuilderFactory', function($http, QueryStringBuilderFactory) {

    return {
      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/rbac/roles';
        this.permissions.service = this.service;
        this.permissionMaps.service = endpoint + '/rbac/role/permission/map';
        return this;
      },

      list: function(props) {
        var q = '';

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + q
        });
      },

      detail: function(id) {
        return $http({
          method: 'get',
          url: this.service + '/' + id
        });
      },

      remove: function(id) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id
        });
      },

      create: function(props) {
        return $http({
          method: 'post',
          url: this.service,
          data: {
            name: props.name,
            permissions: '[]',
            active: props.active
          }
        });
      },

      update: function(props) {
        return $http({
          method: 'put',
          url: this.service,
          data: {
            id: props.id,
            name: props.name,
            permissions: '[]',
            active: props.active,
            createdAt: props.createdAt
          }
        });
      },

      permissions: {
        service: '',

        list: function(id, props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + '/' + id + '/permissions' + q
          });
        }
      },

      permissionMaps: {

        service: '',


        list: function(props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + q
          });
        },

        detail: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/' + id
          });
        },

        remove: function(props) {
          return $http({
            method: 'delete',
            url: this.service,
            data: props.ids
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: [{
              roleId: props.roleId,
              permissionId: props.permissionId
            }]
          });
        },

        batchCreate: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: props.mappings
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service,
            data: {
              id: props.id,
              roleId: props.roleId,
              permissionId: props.permissionId
            }
          });
        }

      }

    };

}]);